import React from "react"
import GuessText from "./GuessText"

function RowsComponent() {

    return (
        <div className="board">
            <div className="row">
                <GuessText attemptNum={0} />
            </div>
            <div className="row">
                <GuessText attemptNum={1} />
            </div>
            <div className="row">
                <GuessText attemptNum={2} />
            </div>
            <div className="row">
                <GuessText attemptNum={3} />
            </div>
            <div className="row">
                <GuessText attemptNum={4} />
            </div>
            <div className="row">
                <GuessText attemptNum={5} />
            </div>

        </div>
    )
}

export default RowsComponent